import { render, staticRenderFns } from "./ShowProjectDetail.vue?vue&type=template&id=1a448714&scoped=true&"
import script from "./ShowProjectDetail.vue?vue&type=script&lang=js&"
export * from "./ShowProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShowProjectDetail.vue?vue&type=style&index=0&id=1a448714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a448714",
  null
  
)

export default component.exports